import {useGetUser} from '@/features/users/queries/useGetUser'
import {ResponseType} from '@/types'
import {AgendaEntity} from '@/features/agenda/types'
import {useGetPatient} from '@/features/patients/services/useGetPatient'

interface UseAgendaEntityResourceProps<T extends ResponseType = 'extended'> {
    entity: AgendaEntity
    id?: string
    responseType?: T
    enabled?: boolean
}

export const useAgendaEntityResource = <T extends ResponseType = 'extended'>({
    entity,
    id,
    responseType = 'extended' as T,
    enabled = true
}: UseAgendaEntityResourceProps<T>) => {
    // Use the appropriate query based on the target
    const userQuery = useGetUser({
        userId: id,
        responseType,
        options: {
            enabled: entity == 'users' && !!id && enabled
        }
    })

    const patientQuery = useGetPatient({
        patientId: id,
        responseType,
        options: {
            enabled: entity == 'patients' && !!id && enabled
        }
    })

    // Return the appropriate query result based on the target
    if (entity == 'users') {
        return {
            data: userQuery.data,
            isLoading: userQuery.isLoading,
            isError: userQuery.isError,
            error: userQuery.error
        }
    }

    return {
        data: patientQuery.data,
        isLoading: patientQuery.isLoading,
        isError: patientQuery.isError,
        error: patientQuery.error
    }
}
